import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LeafConfig, LeafConfigServiceToken, LeafSessionService, selectCurrentAccountData } from '@input-output-labs/ngleaf';

@Component({
  standalone: false,
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent {

  collapsed = false;
  @Output() collapsedChange = new EventEmitter<boolean>();
  isAdmin$: Observable<boolean>;

  constructor(
    public sessionService: LeafSessionService,
    private router: Router,
    private store: Store,
    @Inject(LeafConfigServiceToken) public config: LeafConfig
  ) {
    this.isAdmin$ = this.store.select(selectCurrentAccountData).pipe(
      map(account => account?.admin === true)
    );
  }

  logout() {
    this.sessionService.logout();
  }

  toggleCollapse() {
    this.collapsed = !this.collapsed;
    this.collapsedChange.emit(this.collapsed);
  }
}
